/**
 * PRD §9 veri modelindeki smallint kodlarının tek kaynağı.
 * DB'deki CHECK kısıtları ile birebir aynı olmak zorundadır; migration'lar
 * bu değerleri referans alır.
 */
/** cuzdan.tur */
export const CuzdanTuru = {
    KANTIN: 1,
    YEMEKHANE: 2,
    DEPOZITO: 3,
};
/** bakiye_hareket.tip — KK-202 */
export const HareketTipi = {
    YUKLEME_ONLINE: 1,
    YUKLEME_NAKIT: 2,
    SATIS: 3,
    IADE: 4,
    IPTAL: 5,
    DEPOZITO: 6,
    DEPOZITO_IADE: 7,
    DUZELTME: 8,
    DEVIR: 9,
    /** MVP: okulun IBAN'ına havale/EFT, okul personeli onaylar (KK-1210) */
    YUKLEME_HAVALE: 10,
    /** KK-105 kayıp kart yenileme ücreti */
    KART_UCRETI: 11,
};
export const HAREKET_TIPI_ADI = {
    [HareketTipi.YUKLEME_ONLINE]: "Online yükleme",
    [HareketTipi.YUKLEME_NAKIT]: "Nakit yükleme",
    [HareketTipi.SATIS]: "Satış",
    [HareketTipi.IADE]: "İade",
    [HareketTipi.IPTAL]: "İptal",
    [HareketTipi.DEPOZITO]: "Depozito",
    [HareketTipi.DEPOZITO_IADE]: "Depozito iadesi",
    [HareketTipi.DUZELTME]: "Düzeltme",
    [HareketTipi.DEVIR]: "Devir",
    [HareketTipi.YUKLEME_HAVALE]: "Havale ile yükleme",
    [HareketTipi.KART_UCRETI]: "Kart yenileme ücreti",
};
/** kart.durum */
export const KartDurumu = {
    AKTIF: 1,
    BLOKE: 2,
    IADE: 3,
    HAVUZDA: 4,
};
/** kisitlama.tip */
export const KisitTipi = {
    GUNLUK_LIMIT: 1,
    URUN_YASAK: 2,
    KATEGORI_YASAK: 3,
    ALERJEN_YASAK: 4,
    GUNLUK_ADET: 5,
};
/** kisitlama.kaynak — okul kaydı veliyi ezer */
export const KisitKaynagi = {
    VELI: 1,
    OKUL: 2,
};
/** nokta.tur — 5 DEPO (KK-513) */
export const NoktaTuru = {
    KANTIN: 1,
    YEMEKHANE: 2,
    KIRTASIYE: 3,
    OTOMAT: 4,
    DEPO: 5,
};
/** terminal.durum */
export const TerminalDurumu = {
    AKTIF: 1,
    ASKIDA: 2,
    IPTAL: 3,
};
/** satis.odeme_tipi */
export const OdemeTipi = {
    KART: 1,
    NAKIT: 2,
    CARI: 3,
};
/** satis.durum */
export const SatisDurumu = {
    TAMAM: 1,
    IPTAL: 2,
    MUTABAKAT_BEKLIYOR: 3,
};
/** stok_anlik.durum / stok_hareket.durum — ADR-14, §9.3.1 */
export const StokDurumu = {
    SAGLAM: 1,
    KARANTINA: 2,
    IMHA_BEKLIYOR: 3,
    TEDARIKCI_IADE: 4,
};
export const STOK_DURUM_ADI = {
    [StokDurumu.SAGLAM]: "Sağlam",
    [StokDurumu.KARANTINA]: "Karantina",
    [StokDurumu.IMHA_BEKLIYOR]: "İmha bekliyor",
    [StokDurumu.TEDARIKCI_IADE]: "Tedarikçiye iade",
};
/** stok_hareket.tip */
export const StokHareketTipi = {
    GIRIS: 1,
    SATIS: 2,
    FIRE: 3,
    SAYIM_FARKI: 4,
    TRANSFER: 5,
    TRANSFER_FARKI: 6,
    IADE: 7,
    IMHA: 8,
    DURUM_DEGISIMI: 9,
    SATIS_IPTAL: 10,
};
/** transfer.durum — §9.6.1 durum makinesi */
export const TransferDurumu = {
    TASLAK: 1,
    GONDERILDI: 2,
    TESLIM_ALINDI: 3,
    FARKLI_TESLIM: 4,
    IPTAL: 5,
};
/** transfer.sebep — ck_sebep_durum ile hedef kondisyonu belirler (KK-529) */
export const TransferSebebi = {
    DAGITIM: 1,
    IADE_SATILMAYAN: 2,
    IADE_TARIH_YAKLASAN: 3,
    IADE_TARIH_GECMIS: 4,
    NOKTALAR_ARASI: 5,
};
/** Sebep -> zorunlu hedef kondisyon eşleme (DB'deki ck_sebep_durum ile aynı) */
export const SEBEP_HEDEF_DURUM = {
    [TransferSebebi.DAGITIM]: StokDurumu.SAGLAM,
    [TransferSebebi.NOKTALAR_ARASI]: StokDurumu.SAGLAM,
    [TransferSebebi.IADE_SATILMAYAN]: StokDurumu.SAGLAM,
    [TransferSebebi.IADE_TARIH_YAKLASAN]: StokDurumu.KARANTINA,
    [TransferSebebi.IADE_TARIH_GECMIS]: StokDurumu.IMHA_BEKLIYOR,
};
/** personel.rol — §5.1 RBAC matrisi */
export const Rol = {
    KASIYER: 1,
    NOKTA_SORUMLUSU: 2,
    KANTIN_MUDURU: 3,
    OKUL_YONETIMI: 4,
    OKUL_SISTEM_YONETICISI: 5,
    MALI_MUSAVIR: 6,
};
export const ROL_ADI = {
    [Rol.KASIYER]: "Kasiyer",
    [Rol.NOKTA_SORUMLUSU]: "Nokta görevlisi",
    [Rol.KANTIN_MUDURU]: "Kantin müdürü",
    [Rol.OKUL_YONETIMI]: "Okul yönetimi",
    [Rol.OKUL_SISTEM_YONETICISI]: "Okul sistem yöneticisi",
    [Rol.MALI_MUSAVIR]: "Mali müşavir",
};
/**
 * Tanımlı bütün roller. Rol listesi üreten her yüzey (okul ayarları, personel
 * süzgeci, doğrulama) buradan türer; yeni rol eklendiğinde tek yer güncellenir.
 */
export const TUM_ROLLER = Object.values(Rol);
/** Kart yükleme, talep kararı ve mutabakat yalnızca okul ve muhasebe yetkisidir. */
export const YUKLEME_ROLLERI = [
    Rol.OKUL_YONETIMI,
    Rol.OKUL_SISTEM_YONETICISI,
    Rol.MALI_MUSAVIR,
];
/** Okul yönetim rolleri terminal kurabilir; nokta personeli kod üretemez. */
export const TERMINAL_KURULUM_ROLLERI = [
    Rol.KANTIN_MUDURU,
    Rol.OKUL_YONETIMI,
    Rol.OKUL_SISTEM_YONETICISI,
    Rol.MALI_MUSAVIR,
];
/** Toplu veli giriş bilgisi aktarımı yalnızca okul ve muhasebe yetkisidir. */
export const VELI_GIRIS_AKTARIM_ROLLERI = [
    Rol.OKUL_YONETIMI,
    Rol.OKUL_SISTEM_YONETICISI,
    Rol.MALI_MUSAVIR,
];
/**
 * Rol ATAMA hiyerarşisi. Rol numarası bir KİMLİKTİR, sıra değildir: mali
 * müşavir 6 numaralıdır ama kantin müdürüyle aynı seviyededir. Numarayı sıra
 * saymak, 5'ten büyük numara alan her yeni rolü ATANAMAZ hâle getirirdi —
 * kimse kendi seviyesinin üstüne atama yapamadığı için okul sistem yöneticisi
 * bile mali müşavir tanımlayamazdı.
 */
export const ROL_SIRASI = {
    [Rol.KASIYER]: 1,
    [Rol.NOKTA_SORUMLUSU]: 2,
    [Rol.KANTIN_MUDURU]: 3,
    [Rol.MALI_MUSAVIR]: 3,
    [Rol.OKUL_YONETIMI]: 4,
    [Rol.OKUL_SISTEM_YONETICISI]: 5,
};
/**
 * Stok hareketi (sayım, transfer, karantina kararı) yapabilen roller — §5.1.
 * Kasada da kullanılır: amir onayı gerektiğinde aday listesi bu kümedir.
 */
export const STOK_YETKILI_ROLLER = [
    Rol.NOKTA_SORUMLUSU,
    Rol.KANTIN_MUDURU,
    Rol.OKUL_YONETIMI,
    Rol.OKUL_SISTEM_YONETICISI,
];
/**
 * KK-533: "zahmetli iade akışı fireyi gizler". Fire kaydı para harcamaz,
 * GERÇEĞİ yazar; kasiyeri her fire için amir aramaya zorlamak tam da
 * gizlenmesini istemediğimiz davranışı üretir. Bu yüzden fire kümesi
 * stok kümesinden bir rol GENİŞTİR.
 */
export const FIRE_YETKILI_ROLLER = [
    Rol.KASIYER,
    ...STOK_YETKILI_ROLLER,
];
/**
 * KK-528: imha ONAYLI bir işlemdir. Nokta sorumlusu tek başına imha edemez;
 * stok kümesinden bir rol DARDIR — imha stoğu geri dönüşsüz düşürür ve
 * gideri noktaya yazar (KK-611).
 */
export const IMHA_YETKILI_ROLLER = [
    Rol.KANTIN_MUDURU,
    Rol.OKUL_YONETIMI,
    Rol.OKUL_SISTEM_YONETICISI,
];
/**
 * Tüm noktaları gören roller (KK-1507).
 *
 * Bu küme ÜÇ ayrı yetki taşır ve üçü birlikte verilir: nokta ataması olmadan
 * her terminalde PIN'le oturum açmak, terminale senkronlanmak ve KK-309 müdür
 * onayı vermek. Yalnızca VERİ kapsamı genişletilecekse OKUL_GENELI_VERI_ROLLERI
 * kullanılır — mali müşavirin kasa terminalinde işi yoktur.
 */
export const TUM_NOKTALARI_GOREN_ROLLER = [
    Rol.KANTIN_MUDURU,
    Rol.OKUL_YONETIMI,
    Rol.OKUL_SISTEM_YONETICISI,
];
/**
 * Okul genelinde VERİ gören roller — nokta ataması aranmaz.
 *
 * TUM_NOKTALARI_GOREN_ROLLER'dan farkı, terminale giriş ve müdür onayı
 * yetkisi VERMEMESİDİR. Mali müşavir gideri/geliri hangi noktaya yazarsa
 * yazsın kaydedebilmeli ve raporu okul geneli okuyabilmelidir; ama kasada
 * satış iptal edemez.
 */
export const OKUL_GENELI_VERI_ROLLERI = [
    ...TUM_NOKTALARI_GOREN_ROLLER,
    Rol.MALI_MUSAVIR,
];
/** yukleme_bildirimi.durum — KK-1209/1210 */
export const YuklemeBildirimDurumu = {
    ONAY_BEKLIYOR: 1,
    ONAYLANDI: 2,
    REDDEDILDI: 3,
};
/** nokta.fis_politikasi — KK-542 */
export const FisPolitikasi = {
    KAPALI: 1,
    OPSIYONEL: 2,
    ZORUNLU: 3,
};
/** kisi.tur */
export const KisiTuru = {
    OGRENCI: 1,
    PERSONEL: 2,
    MISAFIR: 3,
};
/** mutabakat_kaydi.sebep */
export const MutabakatSebebi = {
    SUNUCU_REDDI: 1,
    CAPRAZ_LIMIT_ASIMI: 2,
    TRANSFER_FARKI: 3,
    BAKIYE_SAPMASI: 4,
};
/** Sistem varsayılanları */
export const VARSAYILAN = {
    /**
     * KK-405 / AS-06 — terminal başına offline harcama tavanı.
     * 2026-09-14 kararı: fiilen sınırsız. Kasa offline'da da yerel bakiyeyi
     * düşürür; tolerans 0 olan okulda bakiye bitince satış zaten durur.
     * Kolon NOT NULL olduğundan "sınırsız" numeric(12,2) sınırında büyük değerdir.
     */
    OFFLINE_TAVAN: "9999999.99",
    /** KK-204 — eksi bakiye toleransı */
    EKSI_TOLERANS: "0.00",
    /** KK-409 — heartbeat aralığı (sn) */
    HEARTBEAT_SANIYE: 60,
    /** KK-410 — kuyruk boşalmama alarm eşiği (dk) */
    KUYRUK_ALARM_DAKIKA: 120,
    /** NF-13 — kesintisiz offline dayanma hedefi (gün) */
    OFFLINE_DAYANMA_GUN: 7,
    /** §11.2 — delta penceresi dışında kalınca tam yenileme */
    DELTA_PENCERESI_GUN: 7,
    /** Okul saat dilimi varsayılanı (DK-03) */
    SAAT_DILIMI: "Europe/Istanbul",
};
//# sourceMappingURL=sabitler.js.map